/* @flow */
/* eslint-disable no-shadow, no-unused-vars */

import React from 'react';

import InternalLink from './InternalLink';

import type { LinkProps } from './types';

export default function TransactionsLink({
  query, style, className, onClick, children, projectId
}: LinkProps): React.Element {
  return (
    <InternalLink query={query} style={style} className={className}
      projectId={projectId}
      onClick={onClick}
      withProjectPath
      to={`transactions`}>
      {children}
    </InternalLink>
  );
}
